// Mantemos `legacy` apenas por compatibilidade de env var em deploys antigos.
// O renderer legacy (DevExpress) foi removido; `legacy` cai em `native`.
export type AgendaEngine = 'native' | 'legacy';

const ENV_KEY = 'REACT_APP_AGENDA_ENGINE';

export function getAgendaEngine(): AgendaEngine {
    const raw = String(process.env[ENV_KEY] || '').trim().toLowerCase();
    // Compat: valores antigos (ex.: 'legacy') caem em 'native' agora.
    if (raw === 'native') return 'native';
    return 'native';
}
